module.exports = __webpack_public_path__ + "static/media/MichaelPage.6bc7729c.png";